import React, { Component } from 'react';

import Video from 'elements/Video/Video';
import { classnames, classname } from 'utils';

import './Hello.css';

export class Hello extends Component {
  cl = classname('hello');

  state = { isMobile: false };

  componentDidMount() {
    if (typeof window !== 'undefined' && window.matchMedia) {
      this.mediaQuery = window.matchMedia('(max-width: 768px)');
      this.setState({ isMobile: this.mediaQuery.matches });
      this.mediaQuery.addEventListener('change', this.handleMediaChange);
    }
  }

  componentWillUnmount() {
    if (this.mediaQuery) {
      this.mediaQuery.removeEventListener('change', this.handleMediaChange);
    }
  }

  handleMediaChange = (event) => {
    this.setState({ isMobile: event.matches });
  };

  render() {
    const { className, video, poster } = this.props;
    const { isMobile } = this.state;

    const classes = classnames(className, this.cl());
    const posterSrc = poster ? 'https://s3nimax.nimax.ru' + poster : undefined;

    return (
      <div className={classes}>
        <div className={this.cl('wrapper')}>
          <div className={this.cl('about')}>
            <h1 className={this.cl('title')}>
              Создаём опыт&nbsp;бренда,
              <br style={{ display: 'block' }} />
              который работает
              <br style={{ display: 'block' }} />
              на&nbsp;рост бизнеса
            </h1>
            <div className={this.cl('descr')}>
              Помогаем компаниям расти через бренд-опыт: стратегия, интернет-маркетинг и&nbsp;креатив, выстроенные
              в&nbsp;единую систему. Более 70&nbsp;экспертов с&nbsp;опытом в&nbsp;корпоративных и&nbsp;продуктовых
              проектах в&nbsp;технологиях, финансовых сервисах, фармацевтике и&nbsp;товарах массового спроса.
            </div>
            {/* <div className={this.cl('info')}>
              70+&nbsp;экспертов &bull; корпоративный сектор (B2B) и&nbsp;продуктовые проекты &bull; технологическая
              сфера, финтех, фарма, товары повседневного спроса
            </div> */}
          </div>
          {/* <div className={this.cl('services')}>
            <a href="/brands/" className={this.cl('link')}>
              Брендинг
            </a>
            <a href="/ux-ui/" className={this.cl('link')}>
              Дизайн интерфейсов (UX/UI)
            </a>
            <a href="/soft/" className={this.cl('link')}>
              Разработка
            </a>
            <a href="/performance/" className={this.cl('link')}>
              Реклама, SEO
            </a>
            <a href="/media/" className={this.cl('link')}>
              СММ
            </a>
             <a
              href="http://nimax.school/?utm_source=main_page&utm_medium=banner&utm_campaign=menu_btn"
              className={this.cl('link')}
            >
              Образование
            </a> 
          </div> */}
        </div>
        <div className={this.cl('bg')}>
          {isMobile ? (
            <img className={this.cl('video')} src={posterSrc} alt="" loading="lazy" />
          ) : (
            <Video autoplay={true} className={this.cl('video')} src={video} loop={true} poster={poster} />
          )}
        </div>
      </div>
    );
  }
}
